import { PluginSlot } from '@openedx/frontend-plugin-framework';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlay } from '@fortawesome/free-solid-svg-icons';
import { useIntl } from '@edx/frontend-platform/i18n';

import messages from '@src/course-about/course-intro/course-media/messages';
import CourseAboutCourseImageSlot from '@src/plugin-slots/CourseAboutCourseImageSlot';
import type { CourseAboutIntroVideoButtonSlotProps } from './types';

export const CourseAboutIntroVideoButtonSlot = ({
  courseImageSrc, courseImageAltText, openVideoModal,
}: CourseAboutIntroVideoButtonSlotProps) => {
  const intl = useIntl();

  return (
    <PluginSlot
      id="org.openedx.frontend.catalog.course_about_page.intro_video_button"
      slotOptions={{
        mergeProps: true,
      }}
      pluginProps={{
        courseImageSrc,
        courseImageAltText,
        openVideoModal,
      }}
    >
      <button
        type="button"
        className="course-media-video-trigger"
        onClick={openVideoModal}
        aria-label={intl.formatMessage(messages.playCourseIntroductionVideo)}
      >
        <CourseAboutCourseImageSlot imgSrc={courseImageSrc} altText={courseImageAltText} />
        <span className="course-media-video-trigger__caption">
          <FontAwesomeIcon icon={faPlay} />
          {intl.formatMessage(messages.playCourseIntroductionVideo)}
        </span>
      </button>
    </PluginSlot>
  );
};
